(() => {
  if (customElements.get('privado-dock-rail')) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  const smoothstep = (value) => value * value * (3 - 2 * value);

  class PrivadoDockRail extends HTMLElement {
    constructor() {
      super();
      this.items = [];
      this.pointerY = Infinity;
      this.frame = null;
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerLeave = this.handlePointerLeave.bind(this);
      this.animate = this.animate.bind(this);
    }

    connectedCallback() {
      if (!finePointer.matches || prefersReducedMotion.matches) return;

      this.items = Array.from(this.querySelectorAll('.button')).map((element) => ({
        element,
        value: 0,
        target: 0,
        velocity: 0
      }));

      this.addEventListener('pointermove', this.handlePointerMove, { passive: true });
      this.addEventListener('pointerleave', this.handlePointerLeave);
      this.addEventListener('pointercancel', this.handlePointerLeave);
    }

    disconnectedCallback() {
      this.removeEventListener('pointermove', this.handlePointerMove);
      this.removeEventListener('pointerleave', this.handlePointerLeave);
      this.removeEventListener('pointercancel', this.handlePointerLeave);
      window.cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    handlePointerMove(event) {
      this.pointerY = event.clientY;
      this.measureTargets();
      this.requestFrame();
    }

    handlePointerLeave() {
      this.pointerY = Infinity;
      this.items.forEach((item) => {
        item.target = 0;
      });
      this.requestFrame();
    }

    measureTargets() {
      this.items.forEach((item) => {
        const bounds = item.element.getBoundingClientRect();
        const center = bounds.top + bounds.height / 2;
        const distance = Math.abs(this.pointerY - center);
        const proximity = 1 - clamp(distance / 170, 0, 1);
        item.target = smoothstep(proximity);
      });
    }

    requestFrame() {
      if (this.frame) return;
      this.frame = window.requestAnimationFrame(this.animate);
    }

    animate() {
      this.frame = null;
      let active = false;

      if (Number.isFinite(this.pointerY)) {
        this.measureTargets();
      }

      this.items.forEach((item) => {
        item.velocity += (item.target - item.value) * 0.18;
        item.velocity *= 0.68;
        item.value += item.velocity;

        if (Math.abs(item.target - item.value) > 0.002 || Math.abs(item.velocity) > 0.002) {
          active = true;
        }

        const influence = clamp(item.value, 0, 1);
        item.element.style.setProperty('--dock-height', `${56 + influence * 28}px`);
        item.element.style.setProperty('--dock-width', `calc(100% + ${(influence * 2.5).toFixed(3)}rem)`);
        item.element.style.setProperty('--dock-offset', `${(influence * -1.15).toFixed(3)}rem`);
        item.element.style.setProperty('--dock-text-scale', (1 + influence * 0.055).toFixed(4));
        item.element.style.setProperty('--dock-arrow-shift', `${(influence * 0.45).toFixed(3)}rem`);
        item.element.style.setProperty('--dock-arrow-rotate', `${(influence * -18).toFixed(2)}deg`);
        item.element.style.setProperty('--dock-glow', influence.toFixed(4));
        item.element.style.setProperty('--dock-shadow-alpha', (influence * 0.18).toFixed(4));
      });

      if (active) {
        this.requestFrame();
      }
    }
  }

  customElements.define('privado-dock-rail', PrivadoDockRail);
})();
